import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  constructor(private http: HttpClient) {}

  getMemberFunctions(memberId: string): Promise<any> {
    return this.http.get(`@cec-api/church-user-functions/user/${memberId}`).toPromise();
  }
}
